import { ParsedToken } from "firebase/auth";

// Website account management
export interface claimSet {
  browser?: boolean;
  person?: string;
  door?: boolean;
  door_public?: boolean;
  editor?: boolean;
  admin?: boolean;
  stage?: boolean;
}
export type claimKey = keyof claimSet;
export const claimSetKeys = [
  "browser",
  "person",
  "door",
  "door_public",
  "editor",
  "admin",
  "stage",
];

export const toClaimSet = (token: ParsedToken): claimSet => {
  return Object.fromEntries(
    claimSetKeys.map((claim) => [
      claim,
      claim in token ? token[claim] : undefined,
    ])
  );
};
export const claimSetEquivalent = (left: claimSet, right: claimSet) => {
  if (!(left || right)) {
    return true;
  }
  if ((left && !right) || (right && !left)) {
    return false;
  }
  return claimSetKeys.every(
    (key) => left[key as claimKey] === right[key as claimKey]
  );
};

export interface loggedInUser {
  name: string | null | undefined;
  email?: string | null;
  emailVerified?: boolean;
  claims: claimSet;
}

export type loginMethod = "Google" | "Local" | "Token";
